import {
  ACCOUNT_SETTINGS_PATHS,
  ACCOUNT_SETTINGS_USAGE_PAGE_PATHS,
  PROJECT_SETTINGS_PATH,
} from '../routes/account/accountSettingPaths';
import {AUTOMATIONS_PATH} from '../routes/automations/automationsPaths';
import {
  getRouteMatch,
  isCanonicalProfilePath,
  isSpecificPath,
  isUserSettingsPath,
} from '../routes/utils';
import {decodeURIComponentSafe} from '../util/urls';

const ORG_SETTINGS_PATHS = [
  ...ACCOUNT_SETTINGS_PATHS,
  ...ACCOUNT_SETTINGS_USAGE_PAGE_PATHS,
];

/** Header title for account-level pages; undefined for product pages. */
export function accountLevelHeaderTitle(pathname: string): string | undefined {
  if (isUserSettingsPath(pathname)) {
    return 'User settings';
  }
  if (isSpecificPath(pathname, PROJECT_SETTINGS_PATH)) {
    return 'Project settings';
  }
  if (isSpecificPath(pathname, [AUTOMATIONS_PATH])) {
    return 'Automations';
  }
  const params: {orgName?: string; entityName?: string} =
    getRouteMatch(pathname)?.params ?? {};
  if (isSpecificPath(pathname, ORG_SETTINGS_PATHS) && params.orgName != null) {
    return decodeURIComponentSafe(params.orgName);
  }
  if (isCanonicalProfilePath(pathname) && params.entityName != null) {
    return decodeURIComponentSafe(params.entityName);
  }
  return undefined;
}
